import { observable, action } from 'mobx';
import ApiCaller from '../../utils/api-caller';
import LocalStorage from '../../utils/localStorage';

class lateCheckoutStore {

    // Main Properties

    @observable lateCheckoutItems = [];
    @observable lateCheckoutPendingOrder = undefined;
    @observable lateCheckoutRemark = '';

    // LateCheckout Confirm

    @observable lateCheckoutSubTotal = 0;
    @observable lateCheckoutVat = 0;
    @observable lateCheckoutVatTax = 0;
    @observable lateCheckoutServiceFee = 0;
    @observable lateCheckoutServiceFeeTax = 0;
    @observable lateCheckoutTotal = 0;

    // Initialization

    @action initGetLateCheckouts() {
        const that = this;

        if (that.lateCheckoutItems.length === 0) {
            that.lateCheckoutItems = [];

            const languageCode = window.localStorage.getItem('lang') || 'en';
            return ApiCaller.LateCheckouts.apiGetLateCheckouts(languageCode).then((lateCheckoutResponses) => {
                if (lateCheckoutResponses) {
                    that.lateCheckoutItems = lateCheckoutResponses.items;
                }
            });
        } else {
            that.lateCheckoutItems.map(lateCheckoutItem => {
                return lateCheckoutItem.isSelected = false;
            });
        }
    }

    @action refreshLateCheckouts() {
        const that = this;
        that.lateCheckoutItems = [];

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.LateCheckouts.apiGetLateCheckouts(languageCode).then((lateCheckoutResponses) => {
            if (lateCheckoutResponses) {
                that.lateCheckoutItems = lateCheckoutResponses.items;
            }
        })
    }

    @action initLateCheckoutConfirm() {
        this.lateCheckoutRemark = '';

        this.lateCheckoutVatTax = LocalStorage.Get('vat');
        this.lateCheckoutServiceFeeTax = LocalStorage.Get('serviceFee');
        this.lateCheckoutPendingOrder = this.lateCheckoutItems.find(lateCheckoutItem => lateCheckoutItem.isSelected === true);

        if (this.lateCheckoutPendingOrder) {
            this.setLateCheckoutPriceDetail();
        }

        return this.lateCheckoutPendingOrder;
    }

    // GET Properties

    @action getLateCheckoutPendingOrder() {
        const lateCheckoutPendingOrder = this.lateCheckoutItems.find(lateCheckoutItem => lateCheckoutItem.isSelected === true);
        if (lateCheckoutPendingOrder) {
            lateCheckoutPendingOrder.orderQuantity = 1;
        }
        return lateCheckoutPendingOrder;
    }

    // Set Properties

    @action setLateCheckoutIsSelected(taskId, isSelected) {
        this.lateCheckoutItems.map(lateCheckoutItem => {
            return lateCheckoutItem.isSelected = false;
        });

        const lateCheckoutItem = this.lateCheckoutItems.find(x => x.taskId === taskId);
        lateCheckoutItem.isSelected = isSelected;
    }

    @action setLateCheckoutRemark(value) {
        this.lateCheckoutRemark = value;
    }

    @action setLateCheckoutPriceDetail() {
        this.lateCheckoutSubTotal = this.lateCheckoutPendingOrder.price;
        this.lateCheckoutVat = this.lateCheckoutSubTotal * this.lateCheckoutVatTax / 100;
        this.lateCheckoutServiceFee = this.lateCheckoutSubTotal * this.lateCheckoutServiceFeeTax / 100;
        this.lateCheckoutTotal = this.lateCheckoutSubTotal + this.lateCheckoutVat + this.lateCheckoutServiceFee;
    }

    // RESET Properties

    @action resetLateCheckouts() {
        this.lateCheckoutItems = [];
    }
}

export default new lateCheckoutStore()